<style lang="scss" scoped>
.chat-modal::v-deep .v--modal-box {
  overflow: visible;
}
</style>
<template>
  <div v-if="customer">
    <h3>
      {{ customer.name
      }}<span v-if="isDeleted" class="badge badge-danger ml-3">GELÖSCHT</span>
    </h3>
    <div class="row">
      <div class="col-12">
        <resource
          v-if="!isDeleted"
          title="Ändern"
          resource="customerProfile"
          resourceName="Mitglied"
          :original="customer"
          :attributes="[
            {
              name: 'name',
              label: 'Name'
            }
          ]"
        >
          <div slot="title">
            <h4>Profil bearbeiten</h4>
          </div>
        </resource>
      </div>
    </div>
    <div v-if="!isDeleted" class="card card--primary-color card--form mb-3">
      <div class="card-header">
        <h4>Media</h4>
      </div>
      <div class="card-body">
        <support-avatar-upload
          class="mb-3"
          :customer-profile="id"
        ></support-avatar-upload>
        <div class="mb-3">
          <customer-media
            :media="customer.media"
            :update-url="customer.media_update_url"
            :isAvatar="true"
          ></customer-media>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/message"
          :filter="[
            {
              name: 'with',
              value: ['sender', 'receiver']
            },
            {
              name: 'where',
              attributes: {
                sender_id: id
              }
            }
          ]"
          :attributes="[
            {
              attribute: 'id',
              name: 'ID'
            },
            {
              attribute: 'receiver',
              type: 'LinkFriendCell',
              name: 'Chatpartner',
              sortable: false
            },
            {
              name: 'Inhalt',
              type: 'MessageContentCell'
            },
            {
              attribute: 'created_at',
              name: 'Gesendet am',
              type: 'DateTimeCell'
            }
          ]"
        >
          <div slot="title">Nachrichten</div>
        </v-table>
      </div>
    </div>
    <div v-if="!isDeleted" class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/userSession"
          :filter="[
            {
              name: 'where',
              attributes: {
                user_id: customer.user.id
              }
            }
          ]"
          :attributes="[
            {
              attribute: 'ip',
              name: 'IP-Adresse'
            },
            {
              attribute: 'country_code',
              name: 'Land',
              type: 'FlagCell',
              sortable: false
            },
            {
              attribute: 'session_id',
              name: 'Session-ID'
            },
            {
              attribute: 'user_agent',
              name: 'Browser- und Gerätedaten'
            },
            {
              attribute: 'created_at',
              name: 'Erstellt am',
              type: 'DateTimeCell'
            },
            {
              attribute: 'closed_at',
              name: 'Geschlossen am',
              type: 'DateTimeCell'
            },
            {
              attribute: 'duration',
              name: 'Zeitspanne',
              sortable: false
            },
            {
              attribute: 'success',
              name: 'Erfolgreich eingeloggt',
              type: 'CheckMarkerCell'
            }
          ]"
        >
          <div slot="title">Anmeldungen</div>
        </v-table>
      </div>
    </div>
  </div>
</template>

<script>
import SupportAvatarUpload from "@/components/SupportAvatarUpload.vue";
import Autocomplete from "autocomplete-vue";
import CustomerMediaEdit from "@/components/CustomerMediaEdit.vue";

export default {
  components: {
    Autocomplete,
    CustomerMediaEdit,
    SupportAvatarUpload
  },
  created() {
    this.$store
      .dispatch("customerProfile/read", {
        filter: [
          {
            name: "where",
            attributes: {
              id: this.id
            }
          },
          {
            name: "with",
            value: "media"
          }
        ],
        appends: ["ins", "outs"]
      })
      .then(() => {
        this.email = this.customer.user.email;
        this.media = this.customer.media;
      });

    this.$bus.$on("media-uploaded", () => {
      this.loadMedia();
    });

    this.$bus.$on("media-changed", () => {
      this.loadMedia();
    });
  },
  data() {
    return {
      email: "",
      password: "",
      messageSender: "",
      disableModalActions: false,
      mailMessage: "",
      supportMessage: "",
      profileName: "",
      selectedChatProfile: null,
      chatActive: false,
      media: [],
      deleting: false,
      sendingVerificationEmail: false,
      chatProfiles: []
    };
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    customer() {
      return this.$store.getters["customerProfile/find"](this.id);
    },
    isDeleted() {
      return this.customer.deleted_at !== null;
    },
    pictures() {
      return this.media.filter(media => {
        return media.is_image && (media.confirmed || media.is_erotic);
      });
    },
    modalPrefix() {
      return "mitgliederkartei";
    }
  },
  methods: {
    loadChatProfiles() {
      if (this.chatProfiles.length > 0) {
        return;
      }

      this.$http
        .get("/api/v1/customerProfile", {
          params: {
            filter: [
              {
                name: "forSelect"
              },
              {
                name: "withoutTrashed"
              }
            ]
          }
        })
        .then(({ data }) => {
          this.chatProfiles = data;
        });
    },
    deleteUser() {
      if (this.deleting) {
        return;
      }

      let confirmed = confirm("Sicher?");
      if (!confirmed) {
        return;
      }

      this.deleting = true;

      this.$http
        .post("/api/v1/admin-actions/delete/user/" + this.customer.user_id)
        .then(() => {
          this.$notify({
            title: `${this.customer.name} wurde gelöscht`,
            type: "success"
          });

          this.$router.push("/mitglieder/list");
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    persistEmail() {
      this.$http
        .post("/api/v1/admin-actions/change-email/" + this.customer.user.id, {
          email: this.email
        })
        .then(() => {
          this.$notify({
            title: `E-Mail-Adresse aktualisiert`,
            type: "success"
          });
        });
    },
    loadMedia() {
      this.$http.get(this.customer.media_update_url).then(({ data }) => {
        this.media = data;
      });
    }
  },
  watch: {
    id(newId, oldId) {
      this.$store.commit("customerProfile/delete", oldId);
      this.$store
        .dispatch("customerProfile/read", [
          {
            name: "where",
            attributes: {
              id: newId
            }
          }
        ])
        .then(() => {
          this.email = this.customer.user.email;
        });
    }
  },
  destroyed() {
    this.$bus.$off("media-uploaded");
    this.$bus.$off("media-changed");
  }
};
</script>
